import { InteractionRequiredAuthError } from "@azure/msal-common";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { authScopes, protectedResources } from "../../authConfig";
import { callApi } from "../../helpers/call_api";
import { getIdToken } from "../../helpers/msal_auth";
import { RootState } from "../store";
import { UserPermissionSubmitData } from "../../models/UserPermissionData";
import { ErrorData } from "../../models/ErrorData";

export interface SubmitState {
  data: UserPermissionSubmitData | null;
  isLoading: boolean;
}

export type FormErrorData = {
  key: string;
  value: ErrorData;
};
const initialState: SubmitState = {
  data: null,
  isLoading: false,
};

export const submitUserPermissionDataAsync = createAsyncThunk(
  "userPermission/submitChange",
  async (
    payload: UserPermissionSubmitData,
    { rejectWithValue }
  ) => {
    try {
      let idToken = await getIdToken(authScopes);
      const body = JSON.stringify(payload);
      await callApi(
        idToken,
        protectedResources.supportApi + "/admin/userPermissions",
        "POST",
        JSON.parse(body)
      );
    } catch (e) {
      var error = e;
      if (e instanceof InteractionRequiredAuthError) {
        error = new Error(
          JSON.stringify({
            status: 403,
            message: "InteractionRequiredAuthError",
          })
        );
      }
      try {
        var _ = JSON.parse(error.message);
      } catch (objError) {
        if (objError instanceof SyntaxError) {
          error = new Error(
            JSON.stringify({
              status: 500,
              message: error.message,
            })
          );
        }
      }
      return rejectWithValue(error);
    }
  }
);

export const submitUserPermissionDataSlice = createSlice({
  name: "submitUserPermissionData",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(submitUserPermissionDataAsync.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(submitUserPermissionDataAsync.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(submitUserPermissionDataAsync.rejected, (state, action) => {
      state.isLoading = false;
    });
  },
});


export const submitUserPermissionData = (state: RootState) => state.submitUserPermissionData.data;

export const isUserPermissionSubmitLoading = (state: RootState) => state.submitUserPermissionData.isLoading;

export default submitUserPermissionDataSlice.reducer;
